module.exports = __webpack_public_path__ + "c64765d2ec1f5d9fbcf124f8db07a7fb.svg";